import { apiRequest } from ".";

export const fetchTerminations = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/termination',
            token: token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const submitTermination = async (token, data)=>{
    try {
        const response = await apiRequest({
            url: '/termination',
            method: 'POST',
            data: data,
            token: token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateTermination = async (token, data, id)=>{
    try {
        const response = await apiRequest({
            url: `/termination/${id}`,
            method: 'PUT',
            data: data,
            token: token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}